/* eslint-disable no-console */
import * as React from 'react';
import { FormattedMessage } from '@futrli/localisation';
import { getGlobalToast, ToastId, ToastOptions } from './toast-context';

export type { ToastId, ToastOptions };

export const toastSuccess = (message: React.ReactNode | string, options: ToastOptions = {}): ToastId => {
  const toast = getGlobalToast();
  if (!toast) {
    console.warn('ToastProvider is not mounted. Cannot show toast.');
    return -1;
  }
  return toast.show(message, 'success', options);
};

export const toastError = (
  message: React.ReactNode | string = (
    <FormattedMessage
      id="common.generic_system_error"
      defaultMessage="There has been a system error, please try again or contact our support team for further assistance"
    />
  ),
  options: ToastOptions = {}
): ToastId => {
  const toast = getGlobalToast();
  if (!toast) {
    console.warn('ToastProvider is not mounted. Cannot show toast.');
    return -1;
  }
  return toast.show(message, 'error', options);
};

export const toastDismiss = (id: ToastId): void => {
  const toast = getGlobalToast();
  if (toast) {
    toast.dismiss(id);
  }
};
